<template>
  <div class="question-select">
    <div class="question" v-if="!!question">
      {{question}}
    </div>
    <div class="textarea-wrapper">
      <ChatSelect :value="value" @input="onInput" :columns="columns" />
    </div>
  </div>
</template>
<script>
import ChatSelect from "../ChatSelect/index.vue";
export default {
  components: {
    ChatSelect
  },
  props: {
    value: {
      type: Number,
      required: true
    },
    question: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    columns: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      showMask: true,
    }
  },
  methods: {
    onInput(value) {
      this.$emit('input', value)
    },
  }
}


</script>

<style scoped lang="scss">
.chat-textarea{
  width: 100%;
}
.question {
  box-sizing: border-box;
  padding: 0 12px;
  font-size: 12px;
  font-weight: 500;
  line-height: 23px;
  color: rgba(59, 59, 59, 1);
  text-align: left;
  margin-bottom: 12px;
}
.textarea-wrapper {
  width: 100%;
}
</style>